import {isBrowser} from '../_web/utils/environment'
import {Page} from '../analytics/types/Events'
import {generateSearchParams} from './generateSearchParams'
import {DeepLinkSearchParams, OneLinkURLs, Placement} from './types'

// The script uses browser globals so only load it client side
if (isBrowser) {
  require('../_web/appsFlyer/services/smartscript')
}

/**
 * Get the the Universal Deep Link to the mobile app
 * For more information, refer to the documentation at https://innovativetravel.atlassian.net/l/cp/zh7ALw62
 * @param oneLinkURL - The current oneLink url which can be any of `OneLinkURLs` enum values
 * @param page - The current page.
 * @param placement - Name to easily identify the source of installs and clicks. Please determine the value by discussing with the analytics team.
 * @param deepLinkSearchParams - The search parameters.
 */
export const generateAppDownloadUrl = (
  oneLinkURL: OneLinkURLs,
  page: Page,
  placement: Placement,
  deepLinkSearchParams?: DeepLinkSearchParams
) => {
  // The smart script only loads in the browser, so a server render has no way to
  // build the attributed URL. Fall back to the plain OneLink, which still
  // reaches the store, just without the attribution parameters.
  if (!isBrowser || !window.AF_SMART_SCRIPT) return oneLinkURL

  const {
    anonymousId,
    searchId,
    mediaSource: mediaSourceParam,
    ...customSearchParams
  } = deepLinkSearchParams || {}
  const mediaSource = {
    keys: ['utm_source'],
    defaultValue: mediaSourceParam || 'Direct'
  }
  const campaign = {keys: ['utm_campaign']}
  const channel = {keys: ['utm_medium']}
  const afSub1 = {keys: ['label']}
  const afSub3 = {
    keys: [],
    defaultValue: [searchId ? `${anonymousId}_${searchId}` : `${anonymousId}`]
  }
  const afSub5 = {
    keys: [],
    defaultValue: [placement]
  }
  const deepLinkValue = {
    keys: [],
    defaultValue: [page]
  }

  const oneLinkUrl = window.AF_SMART_SCRIPT.generateOneLinkURL({
    oneLinkURL,
    afParameters: {
      mediaSource,
      deepLinkValue,
      campaign,
      channel,
      afSub1,
      afSub3,
      afSub5,
      ...(customSearchParams && {
        afCustom: generateSearchParams(customSearchParams)
      })
    }
  }).clickURL

  const AF_PRIORITY_MODIFIER = 'af_pmod_priority=equal'

  /**
   * The final AppsFlyer link should not be bigger than 2k characters, be mindful about how many parameters you are adding.
   * If there are more than 2k characters, the link may be cut off and the landing link could loose some data.
   */
  return `${oneLinkUrl}&${AF_PRIORITY_MODIFIER}`
}
export {OneLinkURLs}
